import logo from '../../images/logo/logo.png';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useAuth from '../../hooks/UseAuth';

const Header = () => {
    const {user, logOut} = useAuth();
    return (
        <>
            <Navbar bg="white" variant="dark" sticky="top" collapseOnSelect expand="lg">
                <Container
                 style={{width:'100%'}}>
                <Navbar.Brand href="#home">
                    <img style={{width:'120px', height:'40px'}} className="mx-3" src={logo} alt="" />
                    </Navbar.Brand>
                <Navbar.Toggle className="bg-dark" />
                    <Navbar.Collapse className="justify-content-end">
                        <Nav.Link as={Link} to="/home#home" className="text-dark fs-5">Home</Nav.Link>
                        <Nav.Link as={Link} to="/tour#tour" className="text-dark fs-5">Tours</Nav.Link>
                        <Nav.Link as={Link} to="/blog#blog" className="text-dark fs-5">Blog</Nav.Link>
                        <Nav.Link as={Link} to="/order#order" className="text-dark fs-5">Order</Nav.Link>
                        <Nav.Link as={Link} to="/shop#shop" className="text-dark fs-5">Shop</Nav.Link>
                        <Nav.Link as={Link} to="/contact#contact" className="text-dark fs-5">Contact Us</Nav.Link>
                        <span className="text-dark">{user.displayName}</span>
                        {
                        user.email? 
                        <button onClick={logOut}>log out</button>
                        : 
                            <Nav.Link as={Link} to="/login" className="text-dark fs-5"><i className="fas fa-users text-white"></i> Register / Login</Nav.Link>
                        }
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            
        </>
    );
};

export default Header;